// Malaysian DD/MM/YYYY helpers
export function fmtMY(iso) {
  if (!iso) return "—";
  const s = String(iso).slice(0, 10);
  const [y, m, d] = s.split("-");
  if (!y || !m || !d) return iso;
  return `${d}/${m}/${y}`;
}

export function toISOFromMYInput(str) {
  // accepts DD/MM/YYYY or YYYY-MM-DD
  if (!str) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) return str;
  const m = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (m) return `${m[3]}-${m[2]}-${m[1]}`;
  return str;
}

export function daysUntil(iso) {
  if (!iso) return null;
  const d = new Date(String(iso).slice(0, 10));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((d - today) / (1000 * 60 * 60 * 24));
}

export function statusColor(status) {
  switch (status) {
    case "overdue": return "#DA1E28";
    case "pending": return "#F1C21B";
    case "in_progress": return "#0F62FE";
    case "submitted": return "#24A148";
    default: return "#737373";
  }
}

export const KIND_LABEL = {
  annual_return: "Annual Return",
  audit_submission: "Accounts to Audit",
  audited_report: "Audited Report Filing",
};
